const STORAGE_KEY = 'yacc-theme';

/**
 * Returns the active theme. Defaults to 'light' as requested.
 * Users can switch to 'dark' via the theme toggle, which persists in localStorage.
 */
export function getPreferredTheme() {
  if (typeof window === 'undefined') return 'light';
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === 'dark' || saved === 'light') {
    return saved;
  }
  return 'light'; // Light mode is default
}

export function setTheme(theme) {
  if (typeof window === 'undefined') return;
  document.documentElement.setAttribute('data-theme', theme);
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // localStorage might be unavailable in private mode
  }
  window.dispatchEvent(new CustomEvent('yacc-theme-change', { detail: { theme } }));
}

export function toggleTheme() {
  const current = document.documentElement.getAttribute('data-theme') || getPreferredTheme();
  const next = current === 'dark' ? 'light' : 'dark';
  setTheme(next);
  return next;
}
